import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "LiverType",
    isNumber: true,
    isControl: true,
  },
  {
    key: "IsNormal",
    isNumber: true,
  },
];

export const HepatitisTrackingToCaseStatus = {
  label: "肝炎追蹤VS案件狀態",
  key: "HepatitisTrackingToCaseStatus",
  path: "HepatitisTracking/HepatitisTrackingToCaseStatus",
  api: "TCS_V_LiverS011",
  render: (options) => (
    <Diagram.HepatitisTracking.HepatitisTrackingToCaseStatus {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
